import {
  useState,
  forwardRef,
  ForwardedRef,
  useImperativeHandle,
  useEffect,
} from 'react';

import Dialog from '@mui/material/Dialog';
import { Theme, useMediaQuery } from '@mui/material';
import { DialogTransition } from './dialog-transition';

export const withDialog = (Component: any) =>
  forwardRef((props: any, ref: ForwardedRef<ISearchDialogHandle>) => {
    const isMobile = useMediaQuery<Theme>((theme) =>
      theme.breakpoints.down('sm')
    );

    const useDialog = isMobile || props?.dialogMode;
    const [openModal, setOpenModal] = useState(false);

    const closeDialog = () => {
      setOpenModal(false);
    };

    useImperativeHandle(ref, () => ({
      openDialog: () => {
        setOpenModal(true);
      },
      closeDialog,
    }));

    useEffect(() => {
      if (openModal) {
        setTimeout(() => {
          const input = document?.querySelector(
            '#search-input'
          ) as HTMLInputElement;
          input?.focus();
        }, 100);
      }
    }, [openModal]);

    if (!useDialog) return <Component {...props} />;

    return (
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        fullWidth
        maxWidth="md"
        fullScreen={isMobile}
        TransitionComponent={DialogTransition}
        sx={(theme) => ({
          [theme.breakpoints.up('sm')]: {
            '& .MuiDialog-paper': {
              position: 'absolute',
              top: '15%',
            },
          },
          '& .MuiDialog-paper': {
            minHeight: 120,
          },
        })}
      >
        <Component
          {...props}
          showCloseInputIcon
          onClose={() => {
            closeDialog();

            if (props.onClose) {
              props.onClose();
            }
          }}
        />
      </Dialog>
    );
  }) as any;

export interface ISearchDialogHandle {
  openDialog: () => void;
  closeDialog: () => void;
}
